import { render, staticRenderFns } from "./confidentialityRules.vue?vue&type=template&id=23daba1b&scoped=true&"
import script from "./confidentialityRules.vue?vue&type=script&lang=js&"
export * from "./confidentialityRules.vue?vue&type=script&lang=js&"
import style0 from "./confidentialityRules.vue?vue&type=style&index=0&id=23daba1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23daba1b",
  null
  
)

export default component.exports